import React from 'react'
import { useFormContext } from 'react-hook-form';
import '../style.css'
import { checkColor } from '../checkColor';

const Input = ({ element, input }: any) => {

  //  useRef do elemento input, para quando for editar algum vinho e reusar a página Input
  const inputActiveRef = React.useRef<any>(null)

  React.useEffect(() => {

    if (inputActiveRef.current !== null) {
      const elementInput = inputActiveRef.current.lastElementChild
      elementInput.focus({ preventScroll: true })
      elementInput.value = input
      elementInput.style.background = checkColor(input)
      elementInput.addEventListener('change', (e: any) => {
        elementInput.style.background = checkColor(elementInput.value)
      })
    }

  }, [input, inputActiveRef])
  // ...
  const { register, formState: { errors } } = useFormContext();
  // ...
  const handleClick = (e: any) => {
    e.preventDefault()

  }
  return (
    <div ref={inputActiveRef}>
      {/* Input */}
      <label className="w-full text-opacity-75 whitespace-nowrap" htmlFor={element.id}>
        {element.name}
      </label>
      {/* , { required: "Item necessário" } */}
      {
        <select onClick={(e) => handleClick(e)} id={element.id} className={`w-full bg-dark-1 text-white focus:outline-none p-1 whitespace-nowrap select-form rounded`} {...register(`${element.id}`, { required: "Item necessário" })}>
          <option style={{ backgroundColor: 'rgba(6, 78, 59)' }}>Pronto Para Beber</option>
          <option style={{ backgroundColor: 'rgba(30, 58, 138)' }}>Aguardar</option>
          <option style={{ backgroundColor: 'rgba(120, 53, 15)' }}>A Perder</option>
          <option style={{ backgroundColor: 'rgba(127, 29, 29)' }}>Estragado</option>
        </select>
      }
      {/* Error */}
      {(errors[element.id]) && (<p className="text-red-500 whitespace-nowrap">{errors[element.id].message}</p>)}
    </div >
  )
}

export default Input
